export const GET_VERIFIED_BUSINESS_BADGE="GET_VERIFIED_BUSINESS_BADGE"
export const CLEAR_VERIFIED_BUSINESS_BADGE="CLEAR_VERIFIED_BUSINESS_BADGE"